export default {
    name: "RunWorkflow",
    title: "Run Workflow",
    icon: "mdi-cog-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            workflow: null,
            params: [],
            output: "field",
            childAction1: [],
            childAction2: []
        };
    },
};